"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayUtils = void 0;
var ArrayUtils;
(function (ArrayUtils) {
    ArrayUtils.last = function (arr) { return arr[arr.length - 1]; };
    ArrayUtils.range = function (length) {
        var arr = [];
        for (var i = 0; i < length; i++) {
            arr.push(i);
        }
        return arr;
    };
})(ArrayUtils = exports.ArrayUtils || (exports.ArrayUtils = {}));
